import { render, staticRenderFns } from "./LPTemp6.vue?vue&type=template&id=0806b90b&scoped=true&"
import script from "./LPTemp6.vue?vue&type=script&lang=js&"
export * from "./LPTemp6.vue?vue&type=script&lang=js&"
import style0 from "./LPTemp6.vue?vue&type=style&index=0&id=0806b90b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0806b90b",
  null
  
)

export default component.exports